import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuánto tarda en dar resultados?',
    a: 'La mayoría siente alivio la Semana 1 (+2 horas de sueño). Para el Mes 1, deberías tener 8 horas estables.'
  }, {
    q: '¿Puedo usarlo si estoy embarazada?',
    a: 'No. Por seguridad, consulta a tu doctor antes de usar cualquier hierba durante el embarazo o lactancia.'
  }, {
    q: '¿Y si tomo medicamentos?',
    a: 'Chequea la matriz del Capítulo 3 y consulta a tu doctor primero. Algunas plantas pueden interactuar con sedantes.'
  }, {
    q: '¿Frescas o secas?',
    a: 'Frescas son 2x más potentes. La guía te enseña a elegirlas en el mercado.'
  }, {
    q: '¿Sirve para niños?',
    a: 'Solo para mayores de 12 años, usando media dosis. No recomendado para niños pequeños.'
  }, {
    q: '¿Crea adicción?',
    a: 'No. El sistema de rotación está diseñado específicamente para prevenir la tolerancia y dependencia.'
  }, {
    q: '¿Dónde compro en Colombia?',
    a: 'Corabastos, Bogotá es el mejor lugar. También plazas de mercado locales grandes.'
  }, {
    q: '¿Dónde en México?',
    a: 'Mercado Sonora, pasillo 5 es la referencia principal. Pero cualquier mercado grande tiene estas hierbas.'
  }, {
    q: '¿Puedo tomar café?',
    a: "Sí, pero recomendamos hacerlo solo después del 'booster' matutino y evitarlo después de las 2 PM."
  }];
  return <section className="py-12 md:py-20 px-4 bg-forest-900" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <div className="text-center mb-8 md:mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gold-500 mb-4" data-id="element-50">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-3 md:space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-52" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-forest-600 rounded-lg bg-forest-800 overflow-hidden" data-id="element-53">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 md:p-5 text-left hover:bg-forest-700/50 transition-colors" data-id="element-54">
        <span className="font-medium text-cream-100 text-base md:text-lg" data-id="element-55">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-gold-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-56" />
      </button>
      <AnimatePresence data-id="element-57">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-58">
            <div className="p-4 md:p-5 pt-0 text-cream-300 text-sm md:text-base border-t border-forest-700/50" data-id="element-59">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}